(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cc-barra-de-anuncios"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function iniciarBarra(root) {
      if (!root) return;
      if (root.dataset.anunciosIniciado === 'true') return;
      root.dataset.anunciosIniciado = 'true';
      var mensajes = Array.prototype.slice.call(root.querySelectorAll('.barra-anuncios__mensaje'));
      if (mensajes.length < 2) return;
      var velocidad = parseInt(root.getAttribute('data-velocidad'), 10) || 3800;
      var indice = 0;
      root._anunciosTimer = window.setInterval(function () {
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        mensajes[indice].classList.remove('barra-anuncios__mensaje--activo');
        indice = (indice + 1) % mensajes.length;
        mensajes[indice].classList.add('barra-anuncios__mensaje--activo');
      }, velocidad);
    }
    function iniciarTodas() {
      document.querySelectorAll('.barra-anuncios').forEach(iniciarBarra);
    }
    if (document.readyState !== 'loading') {
      iniciarTodas();
    } else {
      document.addEventListener('DOMContentLoaded', iniciarTodas);
    }
    document.addEventListener('shopify:section:load', function (e) {
      var root = e.target.querySelector('.barra-anuncios');
      if (!root) return;
      if (root._anunciosTimer) window.clearInterval(root._anunciosTimer);
      root.dataset.anunciosIniciado = 'false';
      iniciarBarra(root);
    });
    document.addEventListener('shopify:section:unload', function (e) {
      var root = e.target.querySelector('.barra-anuncios');
      if (root && root._anunciosTimer) window.clearInterval(root._anunciosTimer);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cc-faq"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function iniciar(root) {
      if (!root || root.dataset.ccFaqListo === 'true') return;
      root.dataset.ccFaqListo = 'true';

      root.querySelectorAll('.cc-faq__q').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var item = btn.closest('.cc-faq__item');
          var abierto = item.classList.toggle('is-open');
          btn.setAttribute('aria-expanded', abierto ? 'true' : 'false');
        });
      });

      var links = root.querySelectorAll('.cc-faq__rail-link');
      links.forEach(function (link) {
        link.addEventListener('click', function (e) {
          e.preventDefault();
          var id = link.getAttribute('data-target');
          var destino = root.querySelector('#' + id);
          if (destino) {
            var y = destino.getBoundingClientRect().top + window.pageYOffset - 112;
            window.scrollTo({ top: y, behavior: 'smooth' });
          }
          links.forEach(function (l) { l.classList.remove('is-activo'); });
          link.classList.add('is-activo');
        });
      });

      if ('IntersectionObserver' in window) {
        var cats = root.querySelectorAll('.cc-faq__cat');
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              var id = entry.target.id;
              links.forEach(function (l) {
                l.classList.toggle('is-activo', l.getAttribute('data-target') === id);
              });
            }
          });
        }, { rootMargin: '-120px 0px -65% 0px', threshold: 0 });
        cats.forEach(function (c) { io.observe(c); });
      }
    }
    function iniciarTodos() {
      document.querySelectorAll('.cc-faq').forEach(iniciar);
    }
    if (document.readyState !== 'loading') { iniciarTodos(); }
    else { document.addEventListener('DOMContentLoaded', iniciarTodos); }
    document.addEventListener('shopify:section:load', function (e) {
      var r = e.target.querySelector('.cc-faq');
      if (r) { r.dataset.ccFaqListo = 'false'; iniciar(r); }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cc-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function iniciarHero(root) {
      if (!root || root.dataset.ccHeroIniciado === 'true') return;
      root.dataset.ccHeroIniciado = 'true';
      var slides = Array.prototype.slice.call(root.querySelectorAll('.cc-hero__slide'));
      var dots = Array.prototype.slice.call(root.querySelectorAll('.cc-hero__dot'));
      if (slides.length === 0) return;
      var indice = 0;
      var autoplay = root.getAttribute('data-autoplay') === 'true';
      var velocidad = parseInt(root.getAttribute('data-velocidad'), 10) || 6500;
      var timer = null;
      var hover = false;
      function reduce() {
        return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      }
      function mostrar(i) {
        indice = (i + slides.length) % slides.length;
        slides.forEach(function (s, k) {
          s.classList.toggle('is-activa', k === indice);
        });
        dots.forEach(function (d, k) {
          d.classList.toggle('is-activa', k === indice);
        });
      }
      function auto() {
        if (timer) window.clearInterval(timer);
        if (!autoplay || slides.length < 2 || reduce()) return;
        timer = window.setInterval(function () {
          if (!hover) mostrar(indice + 1);
        }, velocidad);
      }
      function paso(d) {
        mostrar(indice + d);
        auto();
      }
      root._ccHeroIr = function (i) {
        mostrar(i);
        auto();
      };
      var prev = root.querySelector('.cc-hero__flecha--prev');
      var next = root.querySelector('.cc-hero__flecha--next');
      if (prev) prev.addEventListener('click', function () { paso(-1); });
      if (next) next.addEventListener('click', function () { paso(1); });
      dots.forEach(function (d, k) {
        d.addEventListener('click', function () { mostrar(k); auto(); });
      });
      root.addEventListener('mouseenter', function () { hover = true; });
      root.addEventListener('mouseleave', function () { hover = false; });
      mostrar(0);
      auto();
    }
    function iniciarTodos() {
      document.querySelectorAll('.cc-hero').forEach(iniciarHero);
    }
    if (document.readyState !== 'loading') {
      iniciarTodos();
    } else {
      document.addEventListener('DOMContentLoaded', iniciarTodos);
    }
    document.addEventListener('shopify:section:load', function (e) {
      var root = e.target.querySelector('.cc-hero');
      if (root) {
        root.dataset.ccHeroIniciado = 'false';
        iniciarHero(root);
      }
    });
    document.addEventListener('shopify:block:select', function (e) {
      var slide = e.target.classList && e.target.classList.contains('cc-hero__slide')
        ? e.target
        : (e.target.closest ? e.target.closest('.cc-hero__slide') : null);
      if (!slide) return;
      var root = slide.closest('.cc-hero');
      if (root && root._ccHeroIr) {
        var slides = Array.prototype.slice.call(root.querySelectorAll('.cc-hero__slide'));
        root._ccHeroIr(slides.indexOf(slide));
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cc-info-producto"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function iniciar(root) {
      if (!root || root.dataset.ccPdpListo === 'true') return;
      root.dataset.ccPdpListo = 'true';
      var main = root.querySelector('.cc-pdp__main-img');
      root.querySelectorAll('.cc-pdp__thumb').forEach(function (t) {
        t.addEventListener('click', function () {
          if (main) main.src = t.getAttribute('data-img');
          root.querySelectorAll('.cc-pdp__thumb').forEach(function (x) { x.classList.remove('is-activa'); });
          t.classList.add('is-activa');
        });
      });
      var input = root.querySelector('.cc-pdp__cant-input');
      root.querySelectorAll('.cc-pdp__cant-btn').forEach(function (b) {
        b.addEventListener('click', function () {
          if (!input) return;
          var v = parseInt(input.value, 10) || 1;
          v = b.getAttribute('data-accion') === 'mas' ? v + 1 : Math.max(1, v - 1);
          input.value = v;
        });
      });
      var variantId = root.querySelector('.cc-pdp__variant-id');
      var precio = root.querySelector('.cc-pdp__precio');
      var botonTexto = root.querySelector('.cc-pdp__boton-texto');
      var baseTexto = botonTexto ? botonTexto.textContent.split(' · ')[0].trim() : '';
      root.querySelectorAll('.cc-pdp__variante').forEach(function (v) {
        v.addEventListener('click', function () {
          root.querySelectorAll('.cc-pdp__variante').forEach(function (x) { x.classList.remove('is-activa'); });
          v.classList.add('is-activa');
          var p = v.getAttribute('data-precio');
          if (variantId) variantId.value = v.getAttribute('data-id');
          if (precio) precio.textContent = p;
          if (botonTexto) botonTexto.textContent = baseTexto + ' · ' + p;
        });
      });
      var form = root.querySelector('[data-cc-pdp-form]');
      if (form) {
        form.addEventListener('submit', function (e) {
          e.preventDefault();
          var boton = form.querySelector('.cc-pdp__boton');
          var etiqueta = form.querySelector('.cc-pdp__boton-texto');
          var textoPrevio = etiqueta ? etiqueta.textContent : '';
          if (boton) boton.setAttribute('disabled', 'disabled');
          if (etiqueta) etiqueta.textContent = 'Agregando…';
          var cartDrawer = document.querySelector('cart-drawer');
          var cartNotification = document.querySelector('cart-notification');
          var receptor = cartDrawer || cartNotification;
          var body = {
            id: variantId ? variantId.value : form.querySelector('[name="id"]').value,
            quantity: parseInt(input ? input.value : 1, 10) || 1
          };
          var config = { 'Content-Type': 'application/json', Accept: 'application/javascript' };
          if (receptor && window.routes) {
            body.sections = receptor.getSectionsToRender
              ? receptor.getSectionsToRender().map(function (s) { return s.id; })
              : undefined;
            body.sections_url = window.location.pathname;
          }
          fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', {
            method: 'POST',
            headers: config,
            body: JSON.stringify(body)
          })
            .then(function (r) { return r.json(); })
            .then(function (data) {
              if (data.status) {
                if (etiqueta) etiqueta.textContent = textoPrevio;
                if (boton) boton.removeAttribute('disabled');
                return;
              }
              if (receptor && receptor.renderContents) {
                if (cartDrawer) {
                  cartDrawer.classList.remove('is-empty');
                  var inner = cartDrawer.querySelector('#CartDrawer');
                  if (inner) inner.classList.remove('is-empty');
                }
                receptor.renderContents(data);
                if (cartDrawer && cartDrawer.open) cartDrawer.open();
              } else {
                document.dispatchEvent(new CustomEvent('cart:refresh'));
                window.location.href = (window.routes && window.routes.cart_url) ? window.routes.cart_url : '/cart';
              }
              if (etiqueta) etiqueta.textContent = textoPrevio;
              if (boton) boton.removeAttribute('disabled');
            })
            .catch(function () {
              if (etiqueta) etiqueta.textContent = textoPrevio;
              if (boton) boton.removeAttribute('disabled');
            });
        });
      }
    }
    function iniciarTodos() {
      document.querySelectorAll('.cc-pdp').forEach(iniciar);
    }
    if (document.readyState !== 'loading') { iniciarTodos(); }
    else { document.addEventListener('DOMContentLoaded', iniciarTodos); }
    document.addEventListener('shopify:section:load', function (e) {
      var r = e.target.querySelector('.cc-pdp');
      if (r) { r.dataset.ccPdpListo = 'false'; iniciar(r); }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      this.setHeaderHeight();
      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');
      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);
      this.createObserver();
    }
    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }
    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });
      observer.observe(this.header);
    }
    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);
          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);
          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }
      this.currentScrollTop = scrollTop;
    }
    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }
    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }
    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }
    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }
    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }
  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
